'use client';

import type { UserFlagsT, UserResponseT } from '@mentimeter/http-clients';
import { core } from '@mentimeter/http-clients';
import React from 'react';
import { useSWRConfig } from 'swr';
import { usersCacheKey } from './cache-keys';

export const useSetUserFlags = () => {
  const { mutate } = useSWRConfig();
  return React.useCallback(
    async (requestFlags: UserFlagsT) => {
      const { data } = await core().users.updateFlags(requestFlags);
      return mutate<UserResponseT>(usersCacheKey, data, { revalidate: false });
    },
    [mutate],
  );
};
